<template>
    <div class="history_list_box">
        <HnDateSearch  :isPage="true" :defaultData="0" @update="dateUpdate" style="margin-top: 10px;" />
        <div class="table_box">
            <el-table :data="tableData" style="width: 100%" class="monitor-table" height="100%">
                <el-table-column label="网络远程监控系统" align="center">
                    <!-- <el-table-column prop="deviceId" label="设备ID" align="center" width="120"></el-table-column> -->
                    <el-table-column prop="signal" label="信号强度" align="center"></el-table-column>
                    <el-table-column prop="powerVoltage" label="供电电压" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="服务器" align="center">
                    <el-table-column prop="cloudServerResTime" label="延迟" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="自定义服务器" align="center">
                    <el-table-column prop="outNetResTime" label="延迟" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="路由器" align="center">
                    <el-table-column prop="routeResTime" label="延迟" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="监控设备" align="center">
                    <el-table-column prop="otherDevResTime" label="延迟" align="center"></el-table-column>
                    <el-table-column prop="otherDevVoltage" label="电压" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="time" label="时间" align="center" width="150"></el-table-column>
            </el-table>
        </div>
        <div class="pages_box" v-if="picTotal > 0">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="picFromInfo.pageIndex"
                :page-size="picFromInfo.pageSize" layout="total, prev, pager, next" class="pageInfo" background :total="picTotal">
              </el-pagination>
        </div>
    </div>
</template>

<script>
    export default {
        props:{
            devCode:String
        },
        watch:{
            devCode(val){
                console.log(val,'val')
                this.picFromInfo.devCode = val
                this.getTableData()
            }
        },
        data(){
            return {
                date:[],
                picFromInfo:{
                    devCode:'',
                    pageIndex:1,
                    pageSize:10,
                    sTime:'',
                    eTime:'',
                    timeType:0
                },
                picTotal:0,
                isPageShow:true,
                tableData: []
            }
        },
        methods:{
            dateUpdate(data){
                Object.assign(this.picFromInfo,data)
                this.getTableData();
            },
            handleCurrentChange(val) {
                this.picFromInfo.pageIndex = val;
                this.getTableData();
            },
            async getTableData() {
                console.log(this.devCode)
                this.picFromInfo.devCode = this.devCode
                const res = await this.$api.IotJKBLHistoricalData(this.picFromInfo)
                this.tableData = res ?.list || []
              
                this.picTotal = res ?.totalCount || 0;
            }
        },
        mounted() {
            this.getTableData();
        }
    }
</script>

<style lang="scss" scoped>
.history_list_box{
    height: 550px;
    display: flex;
    flex-direction: column;
    .table_box{
        flex: 1;
        min-height: 0px;
        margin-top: 10px;
        ::v-deep .el-table--border{
            border: none !important;
        }
        ::v-deep .el-table {
            border: none !important;
        }
        
        ::v-deep .el-table::before {
            display: none !important;
            background-color: transparent !important;
        }
        ::v-deep .el-table--border::after{
            background-color: transparent !important;  
        }
        .monitor-table {
            ::v-deep .el-table__header-wrapper {
                .el-table__header {
                    th {
                        background-color: #2c3e50;
                        color: #ffffff;
                        border: none !important;
                    }
                }
            }
           
            ::v-deep .el-table__body-wrapper {
                .el-table__body {
                    td {
                        border: none !important;
                    }
                }
            }
            
            ::v-deep .el-table__border-line {
                display: none !important;
            }
            
            ::v-deep .el-table__body tr:hover > td {
                background-color: #34495e !important;
            }
            
            
        }
    }
    .pages_box {
        margin: 10px 0 ;
        text-align: right;
    }
}
</style>